export default {
  name: "languages",
  methods: {
    getCulture(culture) {
      return this.$languages.filter(lang => lang.culture == culture)[0]

      //Pour ulaval resource toujours en anglais mais admin en francais
      // return this.$languages.filter(lang => lang.culture == "en")[0]
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./mixins/languages.js
// module id = MvYH
// module chunks = 18